import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208M28.5 12l.337 1.161H30l-.918.71.336 1.129-.918-.71-.918.678.336-1.097-.918-.71h1.133zm-4 8 .337 1.161H26l-.918.71.336 1.129-.918-.71-.918.678.336-1.097-.918-.71h1.133zm0-12 .337 1.161H26l-.918.71.336 1.129-.918-.71-.918.678.336-1.097-.918-.71h1.133zm-4 5 .337 1.161H22l-.918.71.336 1.129-.918-.71-.918.678.336-1.097-.918-.71h1.133z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "m28.837 13.161-.144.042.031.108h.113zm1.163 0 .092.119.347-.269H30zm-.918.71-.092-.119-.082.063.03.099zM29.418 15l-.091.119.368.285-.133-.447zm-.918-.71.092-.118-.09-.07-.091.068zm-.918.678-.144-.044-.133.434.366-.27zm.336-1.097.144.044.03-.1-.082-.063zm-.918-.71v-.15h-.44l.348.269zm1.133 0v.15h.11l.033-.104zm-3.296 8-.144.042.031.108h.113zm1.163 0 .092.119.347-.269H26zm-.918.71-.092-.119-.082.063.03.099zM25.418 23l-.091.119.368.285-.133-.447zm-.918-.71.092-.118-.09-.07-.091.068zm-.918.678-.144-.044-.133.434.366-.27zm.336-1.097.144.044.03-.1-.082-.063zm-.918-.71v-.15h-.44l.348.269zm1.133 0v.15h.11l.033-.105zm.704-12-.144.042.031.108h.113zm1.163 0 .092.119.347-.269H26zm-.918.71-.092-.119-.082.063.03.099zM25.418 11l-.091.119.368.285-.133-.447zm-.918-.71.092-.118-.09-.07-.091.068zm-.918.678-.144-.044-.133.434.366-.27zm.336-1.097.144.044.03-.1-.082-.063zM23 9.161v-.15h-.44l.348.269zm1.133 0v.15h.11l.033-.104zm-3.296 5-.144.042.031.108h.113zm1.163 0 .092.119.347-.269H22zm-.918.71-.092-.119-.082.063.03.099zM21.418 16l-.091.119.368.285-.133-.447zm-.918-.71.092-.118-.09-.07-.091.068zm-.918.678-.144-.044-.133.434.366-.27zm.336-1.097.144.044.03-.1-.082-.063zm-.918-.71v-.15h-.44l.348.269zm1.133 0v.15h.11l.033-.104zm8.223-2.12.337 1.162.288-.083-.337-1.162zm.48 1.27H30v-.3h-1.163zm1.072-.268-.918.71.183.237.919-.71zm-.97.87.337 1.13.287-.086-.337-1.129zm.572.968-.918-.71-.184.238.919.71zm-1.099-.711-.918.677.178.241.918-.677zm-.686.842.337-1.097-.287-.088-.337 1.097zm.285-1.26-.918-.71-.184.238.919.71zm-1.01-.44h1.133v-.3H27zm1.276-.105.367-1.162-.286-.09-.367 1.161zm-3.92 6.835.337 1.161.288-.084-.337-1.16zm.48 1.27H26v-.3h-1.163zm1.072-.27-.918.71.183.238.919-.71zm-.97.872.337 1.129.287-.086-.337-1.129zm.572.967-.918-.71-.184.238.919.71zm-1.099-.711-.918.677.178.241.918-.677zm-.686.842.337-1.097-.287-.088-.337 1.097zm.285-1.26-.918-.71-.184.238.919.71zm-1.01-.44h1.133v-.3H23zm1.276-.106.367-1.16-.286-.091-.367 1.161zm.08-13.164.337 1.161.288-.083-.337-1.162zm.48 1.27H26v-.3h-1.163zm1.072-.27-.918.71.183.238.919-.71zm-.97.872.337 1.129.287-.086-.337-1.129zm.572.967-.918-.71-.184.238.919.71zm-1.099-.711-.918.677.178.241.918-.677zm-.686.842.337-1.097-.287-.088-.337 1.097zm.285-1.26-.918-.71-.184.238.919.71zM23 9.312h1.133v-.3H23zm1.276-.105.367-1.162-.286-.09-.367 1.161zm-3.92 3.835.337 1.161.288-.083-.337-1.162zm.48 1.27H22v-.3h-1.163zm1.072-.27-.918.71.183.238.919-.71zm-.97.872.337 1.129.287-.086-.337-1.129zm.572.967-.918-.71-.184.238.919.71zm-1.099-.711-.918.677.178.241.918-.677zm-.686.842.337-1.097-.287-.088-.337 1.097zm.285-1.26-.918-.71-.184.238.919.71zm-1.01-.44h1.133v-.3H19zm1.276-.105.367-1.162-.286-.09-.367 1.161z"
    }
  )
);
var SvgFlagNzl = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagNzl_default = SvgFlagNzl;

export { FlagNzl_default as default };
